import React from 'react';

import petPartnersHorizontal
from '../../assets/brandLogos/ppi-horizontal-white.svg';
import petPartnersVertical
from '../../assets/brandLogos/ppi-vertical-blue.svg';
import petPartnersVerticalWhite
from '../../assets/brandLogos/ppi-vertical-blue-dark.svg';

import styles from './PetPartnersWelcomeCard.module.css';

export const PetPartnersWelcomeCard = ({ children, initialStep = false }) => (
  <div className={styles.card}>
    <div className={styles.header} data-initial-step={initialStep}>
      <img
        alt=""
        className={styles.logoDesktop}
        src={petPartnersHorizontal}
      />

      <img
        alt=""
        className={styles.logoMobile}
        src={initialStep ? petPartnersVertical : petPartnersVerticalWhite}
      />
    </div>

    <div className={styles.body}>
      {children}
    </div>
  </div>
);
